import type { HistoryPointsType } from "@jti/store/slices/loyaltyCoreSlice";

export const historyItemsAuthoring: HistoryPointsType = {
  isLoaded: true,
  items: [
    {
      date: "2024-10-23T23:01:49+02:00",
      event: "Anniversary",
      points: 100,
      balance: 12448,
      type: "PointsWereAdded",
      coupon: undefined,
      coupon_type: undefined,
      order_id: null,
    },
    {
      date: "2024-10-23T23:01:49+02:00",
      event: "Anniversary",
      points: 10,
      balance: 12558,
      type: "PointsWereRefunded",
      coupon: undefined,
      coupon_type: undefined,
      order_id: "000123",
    },
    {
      date: "2024-10-23T23:01:43+02:00",
      event: "Birthday",
      points: 100,
      balance: 12348,
      type: "PointsWereAdded",
      coupon: undefined,
      coupon_type: undefined,
      order_id: null,
    },
    {
      date: "2024-09-18T15:46:42+02:00",
      event: "Location Prize 3",
      points: 5,
      balance: 12248,
      type: "PointsWereSpent",
      coupon: "new coupon",
      coupon_type: "coupon",
      order_id: null,
    },
    {
      date: "2024-09-15T10:00:00+02:00",
      event: "Reward Redemption",
      points: 50,
      balance: 12198,
      type: "PointsWereSpent",
      coupon: undefined,
      coupon_type: undefined,
      order_id: null,
      issued_reward_status: "canceled",
    },
    {
      date: "2024-09-18T15:46:12+02:00",
      event: "",
      points: 10000,
      balance: 12253,
      type: "PointsWereAdded",
      coupon: undefined,
      coupon_type: undefined,
      order_id: null,
    },
    {
      date: "2024-08-22T03:21:03+02:00",
      event: "Ploom X - Black",
      points: 100,
      balance: 2253,
      type: "PointsWereAdded",
      coupon: undefined,
      coupon_type: undefined,
      order_id: "46467",
    },
    {
      date: "2024-10-23T23:01:49+02:00",
      event: "Anniversary",
      points: 100,
      balance: 12448,
      type: "PointsWereAdded",
      coupon: undefined,
      coupon_type: undefined,
      order_id: null,
    },
    {
      date: "2024-10-23T23:01:43+02:00",
      event: "Birthday",
      points: 100,
      balance: 12348,
      type: "PointsWereAdded",
      coupon: undefined,
      coupon_type: undefined,
      order_id: null,
    },
    {
      date: "2024-09-18T15:46:42+02:00",
      event: "Location Prize 3",
      points: 5,
      balance: 12248,
      type: "PointsWereSpent",
      coupon: "Coupon external",
      coupon_type: "coupon",
      order_id: null,
    },
    {
      date: "2024-09-18T15:46:12+02:00",
      event: "",
      points: 10000,
      balance: 12253,
      type: "PointsWereAdded",
      coupon: undefined,
      coupon_type: undefined,
      order_id: null,
    },
    {
      date: "2024-08-22T03:21:03+02:00",
      event: "Ploom X - Black",
      points: 100,
      balance: 2253,
      type: "PointsWereAdded",
      coupon: undefined,
      coupon_type: undefined,
      order_id: "46467",
    },
  ],
  total: 10,
  statusCode: 200,
};
